/* @flow */
import Reflux from "reflux";

export default {
    getMerchantEvaluations: Reflux.createAction("getMerchantEvaluation") as RefluxAction<[string]>
};
